import { UnknownAction } from "@reduxjs/toolkit";
import {
  CLEAR_LEADS_REPORTS_LEAD,
  RESET_LEADS_REPORTS,
  RESET_LEADS_REPORTS_REPORT_TYPE,
  SELECT_LEADS_REPORTS_LEAD,
  SET_LEADS_REPORTS_DATE_FILTER,
  SET_LEADS_REPORTS_REPORT_TYPE,
} from "../../actions/actionTypes";
import { ReportDateFilter, ReportType, SelectedLead } from "src/types/experiences/leadsAndReports";
import { DEFAULT_REPORT_TYPE } from "src/pages/experiences/leadsAndReports/constants";

export interface LeadsAndReportsState {
  reportType: ReportType;
  dateFilter: ReportDateFilter | null;
  selectedLead: SelectedLead | null;
}

const initialState: LeadsAndReportsState = {
  reportType: DEFAULT_REPORT_TYPE,
  dateFilter: null,
  selectedLead: null,
};

export const leadsAndReportsReducer = (
  state: LeadsAndReportsState = initialState,
  action: UnknownAction,
): LeadsAndReportsState => {
  switch (action.type) {
    case SET_LEADS_REPORTS_REPORT_TYPE:
      return { ...state, reportType: (action as any).payload as ReportType };
    case RESET_LEADS_REPORTS_REPORT_TYPE:
      return { ...state, reportType: DEFAULT_REPORT_TYPE };
    case SET_LEADS_REPORTS_DATE_FILTER:
      return { ...state, dateFilter: (action as any).payload as ReportDateFilter };
    case SELECT_LEADS_REPORTS_LEAD:
      return { ...state, selectedLead: (action as any).payload as SelectedLead };
    case CLEAR_LEADS_REPORTS_LEAD:
      return { ...state, selectedLead: null };
    case RESET_LEADS_REPORTS:
      return initialState;
    default:
      return state;
  }
};
